<template>
    <website-page class="cms-page-qr-scanner" container-class="h-100" page-class="h-100"
                  v-style="cmsWebsite.body.page.style">
        <preview-responsive-container>
            <template v-if="!error">
                <qrcode-stream @decode="onDecode" @init="onInit" :camera="camera">
                    <div class="loading" v-if="loading">
                        Loading
                    </div>
                </qrcode-stream>
                <div class="stream-caption">
                    <em v-tr>Point your camera at a QR code to scan it.|Dirigez votre appareil photo vers un code QR pour le scanner.</em>
                </div>
            </template>
            <div v-show="error">
                <!--            <div class="stream-error">-->
                <!--                <div>-->
                <!--                    <span class="fa-stack fa-2x" style="opacity: 0.5">-->
                <!--                        <i class="fal fa-camera-alt fa-stack-1x text-gray"></i>-->
                <!--                        <i class="fal fa-ban fa-stack-2x"></i>-->
                <!--                    </span>-->
                <!--                    <div class="my-2" v-tr>No camera found|Aucune caméra trouvée</div>-->
                <!--                    <small class="text-gray" v-tr>If you have a camera, make sure to authorize access|Si vous avez une caméra, vérifiez que vous avez autorisé l'accès</small>-->
                <!--                </div>-->
                <!--            </div>-->
                <div class="mt-4">
                    <p v-tr>Take a picture to scan from your device.|Prendre une image à scanner à partir de votre appareil.</p>
                    <qrcode-capture ref="qrCapture" style="display: none" @decode="onDecode" @detect="onDetect"/>
                    <b-btn :block="isMobileLayout" variant="primary" @click="$refs.qrCapture.$el.click()">
                        <span v-tr>Take a picture|Prendre une photo</span>
                    </b-btn>
                </div>
            </div>
        </preview-responsive-container>
    </website-page>
</template>

<script>
import PreviewResponsiveContainer from "@/layout/preview-responsive-container.vue";
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader';

export default {
    name: `cms-page-qr-scanner`,
    components: {PreviewResponsiveContainer, QrcodeCapture, QrcodeStream},
    data() {
        return {
            loading: true,
            error: null,
            camera: `auto`
        };
    },
    mounted() {
        // this.$nextTick(_ => {
        //     this.$refs.qrCapture.$el.removeAttribute(`multiple`);
        // });
    },
    methods: {
        async onInit(promise) {
            try {
                await promise;
                this.loading = false;
            } catch (err) {
                this.error = err;
                this.$emit(`error`, err);
            }
        },
        async onDetect(promise) {
            let { content } = await promise;
            if (!content)
                this.$emit(`invalid`);
        },
        onDecode(res) {
            this.$emit(`input`, `off`);
            this.loading = true;
            this.$emit(`decode`, res, _ => this.loading = false);
            this.$refs.qrCapture.$el.value = null;

            this.showSavedMessage(res);
        }
    }
}
</script>

<style scoped lang="scss">
.stream-caption {
    margin-top: 2rem;
    text-align: center;
}

.stream-error {
    align-self: stretch;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 20rem;
    font-size: 1.1em;
    color: var(--danger);
    border: 1px dashed rgba(0, 0, 0, 0.1);
    text-align: center;
    padding: 1rem;
}
</style>
